<template>
    <div>
        <v-container pa-3>
            <h2 class="pb-5">E-shops and special solutions</h2>
            <v-tabs vertical color="grey">
                <v-tab><span>Welcome</span></v-tab>
                <v-tab><span>Wordpress</span></v-tab>
                <v-tab><span>Magento</span></v-tab>
                <v-tab><span>Prestashop</span></v-tab>
                <v-tab><span>OpenCart</span></v-tab>
                <v-tab-item>
                    <welcome-page />
                </v-tab-item>
                <v-tab-item>
                    <wordpress-plugin-page />
                </v-tab-item>
                <v-tab-item>
                    <magento-plugin-page />
                </v-tab-item>
                <v-tab-item>
                    <prestashop-plugin-page />
                </v-tab-item>
                <v-tab-item>
                    <opencart-plugin-page />
                </v-tab-item>
            </v-tabs>
        </v-container>
    </div>
</template>

<script>
import WelcomePage from "@/views/solutions/pages/welcome-page";
import WordpressPluginPage from "@/views/solutions/pages/wordpress-plugin-page";
import MagentoPluginPage from "@/views/solutions/pages/magento-plugin-page";
import PrestashopPluginPage from "@/views/solutions/pages/prestashop-plugin-page";
import OpencartPluginPage from "@/views/solutions/pages/opencart-plugin-page";

export default {
    name: "landing-page",
    components: { OpencartPluginPage, PrestashopPluginPage, MagentoPluginPage, WordpressPluginPage, WelcomePage }
};
</script>

<style scoped></style>
